<template>
  <div class="sku-list-item"
       :class="{'bordered-box' : removeSideColor, 'clickable-item': legendName === 'misplaced'}"
       @click="openModal">
    <el-row class="sku-list-item-wrapper"
            :style="removeSideColor === false ? `border-left: 7px solid ${borderColor};`:''">
      <el-col v-if="sku.images"
              class="sku-img-col"
              :span="5">
        <img :src="sku.images" :alt="sku.images">
      </el-col>
      <el-col class="sku-info-col" :span="18">
        <span v-if="legendTaskState !== ''"
              class="sku-info-task"
              :class="legendTaskState">
          {{ $t(normalizeString($t(legendTaskState))) }}
        </span>
        <span v-if="sku.display_name">{{ sku.display_name }}</span>
        <span v-if="sku.brand_name">{{ sku.brand_name }}</span>
        <span v-if="sku.size_unit">{{ sku.size + ' ' + sku.size_unit }}</span>
        <span v-if="sku.customer_id">{{ sku.customer_id }}</span>
        <span v-if="legendFacingCount !== ''" class="legend-facing">
          <span class="legend-facing-title">{{ $t(`${normalizeString(legendName)} Facing`) }}:</span>
          <span class="legend-facing-count" :style="`color: ${borderColor}`">{{ legendFacingCount }}</span>
        </span>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="showSkuCardDialog"
               custom-class="inspector-sku-info-dialog"
               append-to-body>
      <div class="inspector-sku-info-card">
        <span v-if="legendTaskState !== ''"
              class="info-card__task-type"
              :class="legendTaskState">
          {{ $t(normalizeString($t(legendTaskState))) }}
        </span>
        <div class="image-wrapper">
          <img v-if="sku.images"
               :src="sku.images"
               :alt="sku.display_name">
        </div>
        <div class="sku-popover-detail">
          <p class="title">
            {{ sku.display_name }}
          </p>
          <el-row v-if="sku.barcode">
            <el-col :span="9">
              <b>{{ $t('Barcode') }}</b>
            </el-col>
            <el-col :span="15">
              {{ sku.barcode }}
            </el-col>
          </el-row>
          <el-row v-if="sku.brand_name">
            <el-col :span="9">
              <b>{{ $t('Brand') }}</b>
            </el-col>
            <el-col :span="15">
              {{ sku.brand_name }}
            </el-col>
          </el-row>
          <el-row v-if="sku.producer_name">
            <el-col :span="9">
              <b>{{ $t('Producer') }}</b>
            </el-col>
            <el-col :span="15">
              {{ sku.producer_name }}
            </el-col>
          </el-row>
          <el-row v-if="sku.customer_id">
            <el-col :span="9">
              <b>{{ $t('Product ID') }}</b>
            </el-col>
            <el-col :span="15">
              {{ sku.customer_id }}
            </el-col>
          </el-row>
          <el-row v-if="sku.size">
            <el-col :span="9">
              <b>{{ $t('Size') }}</b>
            </el-col>
            <el-col :span="15">
              {{ sku.size }} {{ sku.size_unit }}
            </el-col>
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import bus, { EVENTS } from '@/modules/report-inspector/report-inspector-scene/bus';

export default {
  name: 'SkuListItem',
  props: {
    sku: {
      type: Object,
      required: true
    },
    borderColor: {
      type: String,
      default: '#d0d0d0'
    },
    removeSideColor: {
      type: Boolean,
      default: false
    },
    scrollableSkuList: {
      type: Boolean,
      default: false
    },
    legendFacingCount: {
      type: [String, Number],
      default: ''
    },
    legendName: {
      type: String,
      default: ''
    },
    legendTaskState: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showSkuCardDialog: false
    };
  },
  methods: {
    openModal() {
      if (this.scrollableSkuList) {
        this.showSkuCardDialog = true;
      } else {
        const skuIndexInMisplacedList = bus.misplacedList.realogram.findIndex(item => item.id === this.sku.id);

        if (skuIndexInMisplacedList !== -1) {
          bus.selectedMisplacedSkuId = (bus.selectedMisplacedSkuId === this.sku.id.toString()) ? null : this.sku.id.toString();
          bus.$emit(EVENTS.CHANGE_CROP_VISIBILITY);
          bus.$emit(EVENTS.MOVE_TO_SELECTED_CROP, bus.misplacedList.realogram[skuIndexInMisplacedList]);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.sku-list-item {
  box-sizing: border-box;
  padding: 12px 0;
  border-bottom: 1px solid #d0d0d0;

  &.bordered-box {
    height: 86px;
    padding: 7px 0;
    margin-right: 5px;
    border: 1px solid #d0d0d0;
  }

  &-wrapper {
    display: flex;

    @include breakpoint(lg-max) {
      width: 319px;
    }

    .sku-img-col {
      position: relative;
      width: 70px;
      height: 70px;
      padding-bottom: 20%;

      img {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        max-width: 50px;
        max-height: 50px;
        margin: auto;
      }
    }

    .sku-info-col {
      display: flex;
      flex-direction: column;

      span {
        font-size: 12px;
        line-height: 16.34px;
        color: #535353;

        @include breakpoint(lg-max) {
          font-size: 10px;
        }
      }

      .legend-facing {
        display: flex;
        align-items: baseline;

        &-title,
        &-count {
          font-size: 12px;
          font-weight: 700;
          line-height: 18px;
        }

        &-title {
          margin-right: 3px;
          color: #535353;
        }
      }

      .sku-info-task {
        font-size: 13px;
        font-weight: 700;
        line-height: 18px;

        &.out_of_stock {
          color: #f44;
        }

        &.missing {
          color: #f9cb49;
        }

        &.misplaced {
          color: #6efff1;
        }

        &.excess {
          color: #76ff5f;
        }
      }
    }
  }

  &.clickable-item {
    cursor: pointer;
  }
}

.inspector-sku-info-card {
  display: flex;

  .info-card__task-type {
    margin-bottom: 8px;
    font-size: 18px;
    font-weight: 700;
    line-height: 29px;

    &.out_of_stock {
      color: #f44;
    }

    &.missing {
      color: #f9cb49;
    }

    &.misplaced {
      color: #6efff1;
    }

    &.excess {
      color: #76ff5f;
    }
  }

  @include breakpoint(md-max) {
    flex-direction: column;
  }

  @include breakpoint(sm-max) {
    align-items: flex-start;

    &-detail {
      min-width: 312px;
      max-width: 312px;
      margin: 0 0 0 20px;
    }
  }

  .image-wrapper {
    order: 0;
    max-width: 205px;
    max-height: 200px;
    margin: 0 30px 0 0;

    img {
      max-width: 100%;
    }

    @include breakpoint(md-min) {
      display: flex;
      justify-content: center;
      min-width: 225px;
      max-height: max-content;
      margin: 0;
    }

    @include breakpoint(md-max) {
      max-width: initial;
      max-height: 147px;
      margin: 0 auto;

      img {
        max-height: 147px;
      }
    }
  }

  .title {
    margin: 0 0 20px 0;
    font-size: 18px;
    font-weight: bold;
    color: $unitedNationsBlue;
    word-break: break-word;

    @include breakpoint(sm-max) {
      line-height: 21px;
    }

    @include breakpoint(md-max) {
      margin: 20px auto;
    }

    @include breakpoint(md-min) {
      max-width: 90% !important;
    }
  }

  span {
    justify-content: flex-start;
  }

  .sku-popover-detail {
    box-sizing: border-box;
    width: 100%;

    @include breakpoint(lg-max) {
      margin-left: 8px;
    }

    @include breakpoint(md-s-max) {
      display: block;
      order: 2;
      margin: 0 auto;
    }
  }
}

.inspector-sku-info-dialog {
  &.el-dialog {
    width: 100%;
    max-width: 600px;
    margin: 15vh auto;
    border-radius: 6px;

    .el-dialog__header {
      padding: 10px;

      i {
        font-size: 24px;
        font-weight: 900;
      }
    }

    @include breakpoint(md-max) {
      max-width: 319px;
    }
  }
}
</style>
